const SOCIAL_LOGIN_VERSION = '4.0.1';

interface IAPIConfigs {
  apiURL: string;
  socialLoginCallbackUrl: string;
  socialLoginCancelUrl: string;
  socialConnect: string;
}

interface IEnvironments {
  development: IAPIConfigs;
  staging: IAPIConfigs;
  production: IAPIConfigs;
  'dev-production': IAPIConfigs;
}

const getEnv = (): keyof IEnvironments =>
  window.__SPOTIMENV__ || process.env.NODE_ENV || 'production';

const production = {
  apiURL: 'https://www.spot.im/api',
  socialLoginCallbackUrl: `https://app-cdn.spot.im/modules/social-login/${SOCIAL_LOGIN_VERSION}/index.html`,
  socialLoginCancelUrl: `https://app-cdn.spot.im/modules/social-login/${SOCIAL_LOGIN_VERSION}/index.html?cancelled=true`,
  socialConnect: `https://www.spot.im/api/social-connect`
};

const environments: IEnvironments = {
  development: {
    apiURL: 'https://v2.staging-spot.im/api',
    socialLoginCallbackUrl: `https://app-cdn.spot.im/modules/social-login/${SOCIAL_LOGIN_VERSION}/index.html`,
    socialLoginCancelUrl: `https://app-cdn.spot.im/modules/social-login/${SOCIAL_LOGIN_VERSION}/index.html?cancelled=true`,
    socialConnect: `https://v2.staging-spot.im/api/social-connect`
  },
  staging: {
    apiURL: 'https://v2.staging-spot.im/api',
    socialLoginCallbackUrl: `https://app-cdn.spot.im/modules/social-login/${SOCIAL_LOGIN_VERSION}/index.html`,
    socialLoginCancelUrl: `https://app-cdn.spot.im/modules/social-login/${SOCIAL_LOGIN_VERSION}/index.html?cancelled=true`,
    socialConnect: `https://v2.staging-spot.im/api/social-connect`
  },
  production,
  'dev-production': {
    ...production
  }
};

export default environments[getEnv()];
